import cobaltCardTokens from '../../cobalt/components/card.tokens';

const cardTokens = ({ radii }) => {
  const base = cobaltCardTokens({ radii });

  return {
    ...base,
    sizesRadii: {
      ...base.sizesRadii,
      full: radii.big,
    },
  };
};

export default cardTokens;
